import React from "react";
import { motion } from "framer-motion";
import { playLaserSweep } from "../utils/soundEngine";

function SectionDivider() {
  return (
    <div className="container-main py-4">
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        onViewportEnter={() => playLaserSweep()}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative h-px origin-left overflow-hidden"
      >
        {/* Subtle base hairline */}
        <div className="absolute inset-0 bg-surface/[0.06]" />

        {/* Traveling Laser Spark Beam */}
        <motion.div
          initial={{ x: "-100%" }}
          whileInView={{ x: "250%" }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 1.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-y-0 w-1/4 flex items-center"
        >
          {/* Laser beam gradient */}
          <div className="w-full h-full bg-gradient-to-r from-transparent via-emerald-400/50 to-transparent" />
          {/* Glowing laser head spark */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-emerald-400/80 blur-[2px]" />
        </motion.div>
      </motion.div>
    </div>
  );
}

export default SectionDivider;
